<div class="card">
  <div class="card-body">
    <div class="ag-theme-alpine" style="height: 600px; width: 100%;">
      <ag-grid-angular
        style="width: 100%; height: 100%;"
        class="ag-theme-alpine"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [loadingCellRenderer]="loadingCellRenderer"
        [loadingCellRendererParams]="loadingCellRendererParams"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
  <div class="loader"></div>
  <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
